var map = {
	"./CRM.png": 11063,
	"./GD.com.png": 76855,
	"./Messages.png": 83215,
	"./Traceability.png": 71292,
	"./argonomic.png": 17368,
	"./bin_management.png": 64488,
	"./full_portfolio.png": 28513,
	"./icons/argonomic.svg": 98283,
	"./icons/bin_management.svg": 74395,
	"./icons/full_portfolio.svg": 74610,
	"./icons/grower_crm.svg": 29805,
	"./icons/live_market.png": 89773,
	"./icons/logistics.svg": 81025,
	"./icons/messages.png": 92850,
	"./icons/news_alerts.svg": 92389,
	"./icons/private.svg": 77121,
	"./icons/selling.png": 13240,
	"./live_market.png": 87098,
	"./logistics.png": 30314,
	"./news_alerts.png": 66934,
	"./private.png": 81362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57579;